module.exports = __webpack_public_path__ + "img/part2.2d8a13b.png";